module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-hedo-00.2@2x.5e335a67.jpg";